import { useRef } from "preact/hooks";
import type { AccentId } from "../demo-v2/types.js";
import { brandColors } from "./brand-scene.js";
import type { FlowCopy } from "./content.js";
import { useInView, useTicker } from "./motion.js";
import type { TeaserCopy } from "./planner-content.js";
import { InviteMock, Phone } from "./screens.js";

const CYCLE: readonly AccentId[] = ["green", "blue", "pink"];

export function teaserBrand(names: readonly string[], tick: number) {
  return {
    name: names[tick % names.length] ?? "",
    accent: CYCLE[tick % CYCLE.length] as AccentId,
  };
}

export interface TeaserProps {
  readonly copy: TeaserCopy;
  readonly flow: FlowCopy;
}

export function Teaser({ copy, flow }: TeaserProps) {
  const root = useRef<HTMLDivElement>(null);
  const visible = useInView(root);
  const tick = useTicker(2800, visible);
  const brand = teaserBrand(copy.names, tick);
  const colors = brandColors(brand.accent);
  return (
    <div class="teaser" ref={root} data-theme="dark" data-testid="teaser">
      <p class="live-label">
        <span class="live-dot" />
        {copy.label}
      </p>
      <div class="teaser-body">
        <div class="teaser-phone" aria-hidden="true">
          <Phone>
            <div class="phone-page is-on">
              <InviteMock copy={flow} host={brand.name} accent={colors.button} line={colors.line} />
            </div>
          </Phone>
        </div>
        <ul class="teaser-chips">
          {copy.chips.map((chip, index) => (
            <li key={chip} style={{ "--i": index }}>
              {chip}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
